// Decides when a partially typed query is worth asking the server about.
//
// Mirrors Autocomplete::Trigger on the backend so both sides agree on one definition; the
// server re-checks because it cannot trust the client, and the client checks so it does not
// spend a request it knows will be rejected.
//
// The rule is "three characters, or one finished word, whichever comes first". The word
// clause matters for short words: someone typing "ad campaign" has expressed real intent by
// the time they hit the space after "ad", and waiting for a third character of the second
// word would make the dropdown feel late.

// Keep in step with Autocomplete::Config::MIN_CHARACTERS. This is the fallback only; the
// effective value is configurable per organization and enforced server-side.
export const DEFAULT_MIN_CHARACTERS = 3;

// Spaces do not count toward the threshold — "a b" is two characters of intent, not three.
export const significantLength = (query: string): number => query.replace(/\s+/g, '').length;

// A non-space character followed by whitespace means at least one word is complete.
export const hasCompletedWord = (query: string): boolean => /\S\s/.test(query);

export const shouldSuggest = (
  query: string,
  minCharacters: number = DEFAULT_MIN_CHARACTERS
): boolean => {
  if (!query || !query.trim()) { return false; }

  return significantLength(query) >= minCharacters || hasCompletedWord(query);
};
